module.exports = __webpack_public_path__ + "static/media/trag-i1.1b83e575.png";